
import "./Projects.css"
import { projectDetail } from "./data";
import Left from "./ProjectPage/Left";
import Right from "./ProjectPage/Right";

const Projects = () => {
 
    return (
       
          <div className="project-section" id="projects">
        <h2 className="page-header" data-aos="zoom-in">
            Projects
        </h2>
        {
            projectDetail.map( (detail) => detail.id % 2 === 0 ? (<Left detail={detail} key={detail.id}/>) : (<Right detail={detail} key={detail.id}/>) )
        }
       </div>
       
    );
}
export default Projects